import __base_store from '@/store/__base_store'

/**
 * Store de canales de venta.
 */
export default __base_store({
	state: {
		model_name: 'sale_channel',
	},
})

